import * as types from '../constants/ActionTypes';
// import keyBy from 'lodash.keyby'

const initialState = {
  isLoading: false,
  buildings: null
}

export default function profile(state = initialState, action) {
    switch (action.type) {
        case types.LOAD_FAVORITES_START:
          return { ...initialState, isLoading: true };
        case types.LOAD_FAVORITES_SUCCESS:
          return { ...state, ...{buildings: action.payload.data.rows}, isLoading: false };
        case types.LOAD_FAVORITES_ERROR:
          return { ...state, error: action.payload.error, isLoading: false };

        case types.REMOVE_FROM_FAVORITES_SUCCESS:
          if (state.buildings) {
            return { ...state, buildings: state.buildings.filter(building => building.id !== action.payload.buildingId) };
          } else {
            return state
          }
          
        case types.ADD_TO_FAVORITES_SUCCESS:
          if (state.buildings) {
            return { ...state, buildings: state.buildings.concat(action.meta.data) };
          } else {
            return state
          }

        default:
          return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/favorites.js